import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { TransactionStore, TransactionState } from './transaction.store';
import { map } from 'rxjs/operators';
import { TransactionType } from './transaction.model';

@Injectable({ providedIn: 'root' })
export class TransactionQuery extends QueryEntity<TransactionState> {
  constructor(protected store: TransactionStore) {
    super(store);
  }

  getLastSearch(type: TransactionType) {
    const dates = this.getValue().cachedDates[type];
    if (dates.length > 0) {
      return dates[dates.length - 1];
    }
    return undefined;
  }
  /** @deprecated use selectTransactions, this will be changed to return a current value next major release */
  getTransactions(startDate: Date, endDate: Date, type: TransactionType) {
    return this.selectAll().pipe(
      map(ts =>
        ts.filter(
          t =>
            t.TransactionDate > startDate &&
            t.TransactionDate < endDate &&
            t.Type === type
        )
      )
    );
  }

  selectTransactions(startDate?: Date, endDate?: Date, type?: TransactionType) {
    return this.selectAll().pipe(
      map(ts =>
        ts.filter(
          t =>
            (!startDate || t.TransactionDate >= startDate) &&
            (!endDate || t.TransactionDate <= endDate) &&
            (type === undefined || type === null || t.Type === type)
        )
      )
    );
  }
}
